angular.module('um.commonDirectives').directive( 'onElementReady', onElementReadyDirective);

onElementReadyDirective.$inject = ['$parse', '$timeout'];

function onElementReadyDirective( $parse, $timeout ) {
    return {
        restrict: 'A',
        link: function( $scope, elem, attrs ) {
            $scope.elem = elem;
            elem.ready($timeout(function(){
                $scope.$apply(function(){
                    var func = $parse(attrs.onElementReady);
                    func($scope, {$scope: $scope});
                })
            }),0);
        }
    }
}
